//
//
//
//
import ProductInfoList from "./ProductInfoList";
export default {
  components: {
    ProductInfoList: ProductInfoList
  },
  data: function data() {
    return {};
  },
  created: function created() {},
  computed: {},
  methods: {}
};